import { render } from "./CafePage.vue?vue&type=template&id=1753472f"
import script from "./CafePage.vue?vue&type=script&lang=js"
export * from "./CafePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__